import 'whatwg-fetch';
const env = process.env;

const getFacilities = (apiToken) => (
    fetch(`${env.VUE_APP_trimaster}/api/v1/userFacilities/get?access_token=${apiToken}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json'
		}
	})
);

const requestAccessToFacility = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_clientFacilities/requestFacility?access_token=${payload.apitoken}&env=${env.VUE_APP_env}`, {
		method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
	});
};

const getFacilityData = (payload) => {
	return fetch(`${env.VUE_APP_trimaster}/api/v1/facilities/${payload.facility_id}?access_token=${payload.apitoken}&env=${env.env}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json'
		}
	})
}

  const getFacilityById = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/facilities/${payload.facilityId}?access_token=${payload.apitoken}`,{
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${payload.apitoken}`
    }
  });

  const getUserForFacility = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/userFacilities?access_token=${payload.apitoken}&filter[where][facility_id]=${payload.facilityId}`,{
    method: 'GET',
    headers: { 
      Accept: 'application/json',
      Authorization: `Bearer ${payload.apitoken}`
    }
	});
	
 const getActiveFacilities = (payload) => fetch(`${apiUrl}/facilities?access_token=${payload.apitoken}&filter={"where": {"active": 1}}`,{
   method: 'GET',
   headers: {
     Accept:'application/json',
   }
 })

const getNavigationMenus = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/ag_navigationMenus?access_token=${payload.apitoken}&filter={
"include": ["roles"]
}`,{
   method: 'GET',
   headers: {
     Accept:'application/json',
   }
 })


export default {
	getFacilities,
	requestAccessToFacility,
	getFacilityById,
	getUserForFacility,
	getActiveFacilities,
	getFacilityData,
	getNavigationMenus
};
